(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('ngSpinnerBar', ['$rootScope', '$state', '$timeout', NgSpinnerBarFunction]);

    /* Metronic spinner bar */
    function NgSpinnerBarFunction($rootScope, $state, $timeout) {
        var directive = {
            link: link
        };
        return directive;

        function link(scope, element, attrs) {            
            element.addClass('hide'); // hide spinner bar by default

            var activeHttpRequestsListener = $rootScope.$on('ActiveHttpRequests', function(even, args) {                
                if (args.activeRequests <= 0) {
                    element.addClass('hide'); // hide spinner bar                    
                } else {
                    element.removeClass('hide'); // show spinner bar                        
                }
            });
            
            var stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function () {                
                $('body').removeClass('page-on-load'); // remove page loading indicator

                $timeout(function() {
                    Layout.setAngularJsSidebarMenuActiveLink('match', null, $state); // activate selected link in the sidebar menu
                });

                // auto scroll to page top
                setTimeout(function () {
                    App.scrollTop(); // scroll to the top on content load
                }, $rootScope.settings.layout.pageAutoScrollOnLoad);
            });
            
            var stateNotFoundListener = $rootScope.$on('$stateNotFound', function () {
                element.addClass('hide'); // hide spinner bar
            });
            
            var stateChangeErrorListener = $rootScope.$on('$stateChangeError', function () {
                element.addClass('hide'); // hide spinner bar
            });

            scope.$on("$destroy", function () {
                if (activeHttpRequestsListener) {
                    activeHttpRequestsListener();
                }
                if (stateChangeSuccessListener) {
                    stateChangeSuccessListener();
                }
                if (stateNotFoundListener) {
                    stateNotFoundListener();
                }
                if (stateChangeErrorListener) {
                    stateChangeErrorListener();
                }
            });
        }
    }

})();